import { Image, Modal } from "react-bootstrap";

function ImagePreviewModal({ show, onHide, imageUrl }) {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Image Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex justify-content-center">
                <Image src={imageUrl} fluid />
            </Modal.Body>
        </Modal>
    );
}

export default ImagePreviewModal;